import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'

export class AccountService {
  async getAllAccounts(account_id) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${account_id}/accounts/all`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAccountDetails(payload) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${payload.account_id}/accounts`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllAccountsDetails(account_id, page_no, page_size) {
    const params = { page_no, page_size }
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${account_id}/accounts/details`, MICROSERVICES.PROGRAMMANAGER), { params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async updateAccountDetails(payload) {
    try {
      const response = await service.put(Urls.getApiUrl(`admin/${payload.account_id}/accounts`, MICROSERVICES.PROGRAMMANAGER), payload)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getUser(payload) {
    try {
      const response = await service.post(Urls.getApiUrl(`admin/${payload.account_id}/user`, MICROSERVICES.SESSIONMANAGER), { email: payload.email })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async updatePersonalDetails(currentUser, payload) {
    try {
      const response = await service.put(Urls.getApiUrl(`admin/${currentUser.account_id}/user/personal`, MICROSERVICES.SESSIONMANAGER), payload)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const accountService = new AccountService()
